<template>
    <div
        :class="{'v-anchor-navbar': true, 'c-anchor-navbar--fixed': isFixed, 'c-anchor-navbar--toggled': isToggled, 'c-anchor-navbar--mobile': isMenuTooBig}"
        v-scroll="handleScrollThrottled">
        <div ref="wrap" class="c-anchor-navbar__wrap" v-show="isMounted">
            <div class="c-anchor-navbar__toggle" v-show="pinnedAnchor !== null && isToggled === false">
                <button class="c-anchor-navbar__trigger" @click="toggle"
                        v-text="pinnedAnchor && pinnedAnchor.name"></button>
            </div>
            <div :class="{'c-anchor-navbar__inner': true, 'c-anchor-navbar__inner--toggled': isToggled}">
                <a
                    href="#"
                    :class="{'c-anchor-navbar__button': true, 'is-active': isActive(anchor), 'left-border': index === 0, 'right-border': index+1 === scrollAnchors.length }"
                    role="button"
                    v-for="(anchor, index) in scrollAnchors"
                    :key="anchor.id"
                    @click="onClick(anchor, $event)">
                    <span v-text="anchor.name"></span>
                </a>
            </div>
            <!--            <div class="c-anchor-navbar__triangle"></div>-->
        </div>
    </div>
</template>
<script lang="ts">
import minBy from 'lodash/minBy';
import throttle from 'lodash/throttle';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { EventBus } from '../helpers/bus';
import { ScrollAnchor } from '../store/modules/ui';
import BaseComponent from './Base';

const UiStore = namespace('ui');

@Component
export default class AnchorNavbar extends BaseComponent {
    public $refs: {
        wrap: HTMLElement;
    };

    @UiStore.State('scrollAnchors') protected readonly scrollAnchors: ScrollAnchor[];

    protected handleScrollThrottled = throttle(this.handleScroll, 100, {leading: false});
    protected pageYOffset: number = window.pageYOffset;
    protected navbarYOffset: number = 0;
    protected offsetCoeff: number = 80;
    protected isToggled: boolean = false;
    protected isMounted: boolean = false;
    protected isMenuTooBig: boolean = false;

    protected body: HTMLElement = document.body;

    protected get isFixed(): boolean {
        return (this.navbarYOffset - this.offsetCoeff) <= this.pageYOffset;
    }

    public onClick(anchor: ScrollAnchor, event: Event): void {
        this.isToggled = false;
        window.scrollTo({
          top: (anchor.el.elm as HTMLElement).offsetTop - this.$el.getBoundingClientRect().height,
          behavior: 'smooth',
        });
        event.preventDefault();
    }

    protected get pinnedAnchor(): ScrollAnchor | null {
        if (this.activeAnchor !== null) {
            return this.activeAnchor;
        }
        if (this.scrollAnchors.length > 0) {
            return this.scrollAnchors[0];
        }
        return null;
    }

    protected get activeAnchor(): ScrollAnchor | null {
        if (this.scrollAnchors.length === 0) {
            return null;
        }
        const prevAnchors = this.scrollAnchors.filter((anchor: ScrollAnchor) => {
            return ((anchor.el.elm as HTMLElement).offsetTop - this.offsetCoeff) <= this.pageYOffset;
        });
        return minBy<ScrollAnchor>(prevAnchors, (anchor: ScrollAnchor) => {
            return this.pageYOffset - (anchor.el.elm as HTMLElement).offsetTop - this.offsetCoeff;
        }) || null;
    }

    public isActive(anchor: ScrollAnchor): boolean {
        if (this.activeAnchor === null) {
            return false;
        }
        return anchor.id === this.activeAnchor.id;
    }

    public handleScroll(): void {
        const baseMenuNode = document.getElementById('mobile-menu');
        if (baseMenuNode) {
            const element = baseMenuNode.children && baseMenuNode.children.length ? baseMenuNode.children[0] : null;
            if (element) {
                const mobileMenuElement: HTMLElement = element as HTMLElement;
                if (mobileMenuElement.offsetHeight && mobileMenuElement.offsetHeight > 0) {
                    this.body.classList.remove('has-fixed-anchor-navbar');
                    return;
                }
            }
        }

        this.$set(this, 'pageYOffset', window.pageYOffset);
        if (!this.body) {
            return;
        }
        if (this.isFixed) {
            this.body.classList.add('has-fixed-anchor-navbar');
        } else {
            this.body.classList.remove('has-fixed-anchor-navbar');
        }
    }

    public toggle(): void {
        this.isToggled = !this.isToggled;
    }

    protected onWindowResize(): void {
        this.navbarYOffset = this.$el.offsetTop + this.$el.offsetHeight;
    }

    protected mounted(): void {
        this.isMounted = true;
        this.onWindowResize();
        // if (window.outerWidth < 769) {
        //     this.offsetCoeff = 300;
        // }
        EventBus.$on(['ready', 'load', 'windowResize', 'orientationChange', 'appMounted'], () => {
            this.onWindowResize();
        });
        // EventBus.$on(['load', 'orientationChange'], () => {
        //     this.isMenuTooBig = this.$el.offsetHeight < this.$refs.wrap.offsetHeight;
        // });
    }
}
</script>
